module.exports = {
  login: 'Login to view vouchers',
  vouchersTitle: 'Vouchers',
  headings: {
    voucher: 'Voucher',
    booking: 'Booking',
    redeemed: 'Redeemed',
    balance: 'Balance',
    created: 'Created',
    expiry: 'Expiry'
  },
  types: {
    active: 'Active',
    redeemed: 'Redeemed',
    refunded: 'Refunded',
    expired: 'Expired'
  },
  vouchersFor: 'Vouchers for',
  noVouchersFound: 'Sorry no vouchers found'
}



// WEBPACK FOOTER //
// ./shared/config/components/vouchers/uk/index.js